<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.</p>
<p class="copyright"><span class="small">HOUSE OF REEDS</span></p>
<p class="copyright">Copyright <sup>©</sup> 2004 by Thomas Harlan</p>
<p class="copyright">All rights reserved, including the right to reproduce this book, or portions thereof, in any form.</p>
<p class="copyright">This book is printed on acid-free paper.</p>
<p class="copyright">Map by the author</p>
<p class="copyright">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright"><span class="weblink"><a class="nounder" href="http://www.tor.com" target="_blank">www.tor.com</a></span></p>
<p class="copyright">Tor® is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Harlan, Thomas.</p>
<p class="copyright2">House of reeds / Thomas Harlan.—1st ed.</p>
<p class="copyright3">p. cm.</p>
<p class="copyright2">“A Tom Doherty Associates book.”</p>
<p class="copyright2">Sequel to: Wasteland of flint.</p>
<p class="copyright2">ISBN 0-765-30193-8 (acid-free paper)</p>
<p class="copyright3">1. Life on other planets—Fiction. 2. Space colonies—Fiction. 3. Mexico—Fiction. 4. Aztecs—Fiction. I. Title.</p>
<p class="copyrightt">PS3558.A624244H68 2004<br/>813’.54—dc22</p>
<p class="copyright4">2003057060</p>
<p class="copyright">First Edition: February 2004</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3e38f0e2